
export default {
    props: {
        src: { type: String, required: true },
        aspectRatio: { type: String, default: '16:9' },
        lazy: { type: Boolean, default: true },
        // only has effect with lazy
        blur: { type: Boolean, default: true },
        trans: { type: Boolean, default: true },
        bg: { type: String, default: '' },
        animated: { type: Boolean, default: false },
        hasBackground: { type: Boolean, default: false },
        grayscale: { type: Boolean, default: false }
    },
    data: () => ({
        sizes: [500, 350, 240],
        dpr: null,
    }),
    computed: {
        imageBase() {
            return `${this.src}?ar=${this.aspectRatio}&fit=crop&auto=compress&cs=srgb&dpr=${this.dpr}`;
        },
        lowImg() {
            return `${this.imageBase}&w=50`;
        },
        highImg() {
            return this.bg
                ? `${this.imageBase}&w=${this.sizes[0]}&bg=${this.bg}`
                : `${this.imageBase}&w=${this.sizes[0]}`;
        },
        srcset() {
            const imgArr = this.sizes.map(x => {
                return this.bg ? `${this.imageBase}&w=${x}&bg=${this.bg} ${x}w` : `${this.imageBase}&w=${x} ${x}w`;
            });
            return imgArr.join(', ');
        },
        paddingBottom() {
            const split = this.aspectRatio.split(':');
            const width = parseInt(split[0]);
            const height = parseInt(split[1]);
            return `${100 / (width / height)}%`;
        },
        style() {
            return {
                paddingBottom: this.paddingBottom,
            };
        },
    },
    mounted() {
        this.dpr = window.devicePixelRatio;
    },
};
